import { ɵɵdefineInjectable, ɵɵinject, Injectable, InjectionToken, INJECTOR, Injector, Optional, Inject, Pipe, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { from, BehaviorSubject, Subject, of, throwError, forkJoin } from 'rxjs';
import { take, finalize, map, tap, catchError, mergeMap, switchMap } from 'rxjs/operators';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { AccessRequestsModuleConfigService } from '@mt-ng2/access-requests-module-config';
import { HttpClient, HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { isNull, isNullOrWhitespace } from '@mt-ng2/common-functions';
import { EnvironmentService } from '@mt-ng2/environment-module';
import { StorageService } from '@mt-ng2/common-classes';
import { DomSanitizer } from '@angular/platform-browser';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@mt-ng2/environment-module';
import * as ɵngcc2 from '@mt-ng2/common-classes';
import * as ɵngcc3 from '@angular/common/http';
import * as ɵngcc4 from '@angular/router';
import * as ɵngcc5 from '@angular/platform-browser';
class TokenService {
    constructor(environmentService, storageService) {
        this.environmentService = environmentService;
        this.storageService = storageService;
        this.tokenKey = '';
        this.xsrfTokenKey = '';
        const tokenPrefix = `${this.environmentService.config.appName}-${this.environmentService.config.appVersion}`;
        this.tokenKey = tokenPrefix + '-jwt';
        this.xsrfTokenKey = tokenPrefix + '-XSRF-TOKEN';
    }
    /**
     * Return the currently saved token from the cookie
     */
    getTokenFromCookie() {
        // pull token from cookie
        return from(this.storageService.get(this.tokenKey));
    }
    /**
     * Save the jwt token in the cookie
     */
    saveJwtTokenInCookie(tokenObj) {
        if (tokenObj.remember) {
            const cookieExpiration = new Date();
            // save refresh token in cookie for 1 month on each refresh
            // auth token will expire before cookie does but refresh will not
            cookieExpiration.setDate(cookieExpiration.getDate() + 30);
            this.storageService.set(this.tokenKey, JSON.stringify(tokenObj), { expires: cookieExpiration });
        }
        else {
            this.storageService.set(this.tokenKey, JSON.stringify(tokenObj), { expires: '' });
        }
    }
    /**
     * Return the currently saved xsrf token from the cookie
     */
    getXsrfTokenFromCookie() {
        // pull token from cookie
        return from(this.storageService.get(this.xsrfTokenKey));
    }
    /**
     * Save the xsrf token in the cookie
     */
    saveXsrfTokenInCookie(tokenObj, remember) {
        if (remember) {
            const cookieExpiration = new Date();
            cookieExpiration.setDate(cookieExpiration.getDate() + 30);
            this.storageService.set(this.xsrfTokenKey, tokenObj, { expires: cookieExpiration });
        }
        else {
            this.storageService.set(this.xsrfTokenKey, tokenObj, {
                expires: '',
            });
        }
    }
    /**
     * Clear jwt and xsrf token from cookies and observables
     */
    clearTokens() {
        this.storageService.remove(this.tokenKey);
        this.storageService.remove(this.xsrfTokenKey);
    }
}
TokenService.ɵfac = function TokenService_Factory(t) { return new (t || TokenService)(ɵngcc0.ɵɵinject(ɵngcc1.EnvironmentService), ɵngcc0.ɵɵinject(ɵngcc2.StorageService)); };
TokenService.ɵprov = ɵɵdefineInjectable({ factory: function TokenService_Factory() { return new TokenService(ɵɵinject(EnvironmentService), ɵɵinject(StorageService)); }, token: TokenService, providedIn: "root" });
TokenService.ctorParameters = () => [
    { type: EnvironmentService },
    { type: StorageService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TokenService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.EnvironmentService }, { type: ɵngcc2.StorageService }]; }, null); })();

const WINDOW = new InjectionToken('Window');
function _window() {
    return window;
}

const defaultLoggedInUser = {
    AuthId: 0,
    ClaimValues: {},
    CustomOptions: {},
    Email: '',
    Id: 0,
    Name: '',
    ProfileImagePath: 'default.png',
};
function getDefaultLoggedInUser() {
    return Object.assign({}, defaultLoggedInUser);
}
/***
 * This will fill the default value for customoptions and stich the @see{@link ILoginResponse}
 * properties custom options together to make a single custom object for the
 * front end to work with.
 * @param data
 */
function stitchCustomOptions(data) {
    data.LoginResult.CustomOptions = data.LoginResult.CustomOptions || {};
    data.UserDetails.CustomOptions = data.UserDetails.CustomOptions || {};
    const customOptions = Object.assign(Object.assign({}, data.LoginResult.CustomOptions), data.UserDetails.CustomOptions);
    return customOptions;
}
function matchPassword(form, formname = 'AuthUser') {
    let checkform = formname !== null ? form.get(formname) : form;
    let password = checkform.value.Password;
    let confirmPassword = checkform.value.ConfirmPassword;
    if (password !== confirmPassword) {
        flipPasswordsErrors(checkform, true);
        return false;
    }
    else {
        flipPasswordsErrors(checkform, null);
    }
    return true;
}
function flipPasswordsErrors(form, value) {
    let confirmPasswordForm = form.get('ConfirmPassword');
    let passwordForm = form.get('ConfirmPassword');
    confirmPasswordForm.setErrors({ matchPassword: value });
    passwordForm.setErrors({ matchPassword: value });
    confirmPasswordForm.updateValueAndValidity();
    passwordForm.updateValueAndValidity();
}
function getLoggedInFromToken(token) {
    return {
        AuthId: token.authUserId,
        ClaimValues: token.claimValues,
        CustomOptions: token.customOptions,
        Email: token.email,
        Id: token.userId,
        Name: token.name,
        ProfileImagePath: token.img,
    };
}

function mapToken(data, remember) {
    const image = data.UserDetails.ProfileImagePath || '';
    const claims = data.LoginResult.ClaimFlags || {};
    remember = remember || false;
    const token = {
        authUserId: data.LoginResult.AuthId,
        claimValues: claims,
        customOptions: stitchCustomOptions(data),
        email: data.UserDetails.Email,
        expires: data.LoginResult.ExpiresUtc,
        img: image,
        issued: data.LoginResult.IssuedUtc,
        name: data.UserDetails.Name,
        refreshId: data.LoginResult.RefreshTokenIdentifier,
        remember: remember,
        token: data.LoginResult.Jwt,
        userId: data.UserDetails.Id,
    };
    return token;
}

/**
 * utility function that runs a before handler if present and safely handles if not present
 *
 * NOTE:  Do not use outside of AuthModule.  If needed outside this module, add to the common
 * module or make a new module for these (discuss with NGIN).
 * @example
 * handlerExecuteSafe(
 *     logoutDetails.onBeforeLogoutHandler, // may have a before handler OR may be null
 *     () => this.processLogout(logoutDetails.currentUser, bypassRoute), // what to do either way
 * );
 * @param handler - observable to await if present
 * @param after - function to run either way.  Runs even if handler was present but returned unsuccessful.
 */
function handlerExecuteSafe(handler, after) {
    if (handler) {
        handler.pipe(take(1), finalize(after)).subscribe();
    }
    else {
        after();
    }
}

const defaultConfig = {
    messageOverrides: {
        missingPermissionMessage: 'You do not have permission to access this page',
        requiresLoginMessage: 'Looks like you are not signed in, please login',
    },
    pathOverrides: {
        homePath: '/home',
        loginPath: '/login',
        myProfilePath: '/users/my-profile',
    },
};
const AuthModuleConfigToken = new InjectionToken('auth_module_config');
class AuthConfig {
    constructor(injector) {
        let config = injector.get(AuthModuleConfigToken, {});
        if (!config) {
            config = {};
        }
        this.messages = Object.assign({}, defaultConfig.messageOverrides, config.messageOverrides);
        this.paths = Object.assign({}, defaultConfig.pathOverrides, config.pathOverrides);
        this.eventHandlers = Object.assign({}, config.eventHandlers);
    }
}
AuthConfig.ɵfac = function AuthConfig_Factory(t) { return new (t || AuthConfig)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
AuthConfig.ɵprov = ɵɵdefineInjectable({ factory: function AuthConfig_Factory() { return new AuthConfig(ɵɵinject(INJECTOR)); }, token: AuthConfig, providedIn: "root" });
AuthConfig.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthConfig, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

/**
 * used to replace a behavior subject with something that does not have the ability
 * to change the internal value, since it is missing the next function.
 */
class BehaviorSubjectWithoutNext {
    constructor(behaviorSubject) {
        this._originalSubject = behaviorSubject;
    }
    get value() {
        return this.getValue();
    }
    subscribe(next, error, complete) {
        return this._originalSubject.subscribe(next, error, complete);
    }
    unsubscribe() {
        this._originalSubject.unsubscribe();
    }
    get closed() {
        return this._originalSubject.closed;
    }
    getValue() {
        let value = this._originalSubject.getValue();
        return this.breakRef(value);
    }
    asObservable() {
        return this._originalSubject.asObservable().pipe(map((value) => this.breakRef(value)));
    }
    /**
     * return a value that does not refer to the original value, so that if changes are made
     * to the new object, those changes will not mutate the original object.
     */
    breakRef(value) {
        if (value) {
            value = JSON.parse(JSON.stringify(value));
        }
        return value;
    }
}

/**
 * Angular service responsible for handling login, authentication, storage and retrieval of tokens,
 * and the currently logged in user.
 */
class AuthService {
    constructor(environmentService, http, tokenService, router, _window, authConfig) {
        this.environmentService = environmentService;
        this.http = http;
        this.tokenService = tokenService;
        this.router = router;
        this._window = _window;
        this.authConfig = authConfig;
        /**
         * Observable of the currently logged in user.
         */
        this._currentUser = new BehaviorSubject(getDefaultLoggedInUser());
        this._refreshTokenInProgress = false;
        this._tokenRefreshed$ = new Subject();
        this.appReady = new BehaviorSubject(null);
        this.getToken().subscribe((token) => {
            if (token && token.name) {
                this._updateCurrentUser(getLoggedInFromToken(token));
            }
        }, () => { });
    }
    get currentUser() {
        if (!this._currentUserWithoutNext) {
            this._currentUserWithoutNext = new BehaviorSubjectWithoutNext(this._currentUser);
        }
        return this._currentUserWithoutNext;
    }
    /**
     * Calls the user authentication endpoint and returns a login response.  If the login
     * was successful, it also saves the token and updates the currentUser property.
     * @param {string} username
     * @param {string} password
     * @param {boolean} remember
     * @returns {Observable<ILoginResponse>} the login response
     */
    login(username, password, remember) {
        const data = {
            AuthClientID: this.environmentService.config.authClientId,
            AuthClientSecret: this.environmentService.config.authSecretVariable,
            Password: password,
            Username: username,
        };
        return this.http.post('/authUsers/token', data).pipe(tap(this.handleLogin.bind(this)));
    }
    /**
     * Calls the google user authentication endpoint and returns a login response.  If the login
     * was successful, it also saves the token and updates the currentUser property.
     * @param {IGoogleLoginObject} googleLoginObject Object containing data provided by google login.  Created automatically by functionality in login package.
     * @returns {Observable<ILoginResponse>} the login response
     */
    googleLogin(googleLoginObject) {
        const data = {
            AuthClientID: this.environmentService.config.authClientId,
            AuthClientSecret: this.environmentService.config.authSecretVariable,
            Email: googleLoginObject.email,
            FirstName: googleLoginObject.firstName,
            LastName: googleLoginObject.lastName,
            Token: googleLoginObject.token,
        };
        return this.http.post('/authUsers/google/token', data).pipe(tap(this.handleLogin.bind(this)));
    }
    /**
     *
     * @param microsoftLoginObject Object containing data provided by microsoft login.  Created automatically by Microsoft popup in login package.
     * @returns {Observable<ILoginResponse>} the login response
     */
    microsoftLogin(microsoftLoginObject) {
        const data = {
            AuthClientId: this.environmentService.config.authClientId,
            AuthClientSecret: this.environmentService.config.authSecretVariable,
            Email: microsoftLoginObject.account.username,
            Token: microsoftLoginObject.accessToken,
        };
        return this.http.post('/auth/microsoft', data).pipe(tap(this.handleLogin.bind(this)));
    }
    handleLogin(response) {
        this.saveToken(response, true);
        const loginHandler = this.authConfig.eventHandlers.onLogin;
        if (loginHandler) {
            loginHandler(response);
        }
    }
    /**
     * Clears out all tokens, updates the currentUser to be the default user, and either reloads the page
     * or navigates to the login route based on the bypassRoute param.  Fires OnLogout and OnBeforeLogout events
     * if handlers provided in the auth config.
     * @param {boolean} bypassRoute flag that if passed in as true, will reload the current window.
     * If not passed in or passed in as false, will navigate to the login route.
     */
    logout(bypassRoute) {
        const logoutDetails = this.getLogoutDetails();
        handlerExecuteSafe(logoutDetails.onBeforeLogoutHandler, () => this.processLogout(logoutDetails.currentUser, bypassRoute, logoutDetails.onLogout));
    }
    /**
     * gets details for the logout process, including current user info and auth config event handlers.
     */
    getLogoutDetails() {
        const currentUser = this.currentUser.getValue();
        const currentUserDetails = {
            CustomOptions: currentUser.CustomOptions,
            Email: currentUser.Email,
            Id: currentUser.Id,
            Name: currentUser.Name,
            ProfileImagePath: currentUser.ProfileImagePath,
        };
        return {
            currentUser: currentUserDetails,
            onBeforeLogoutHandler: (this.authConfig.eventHandlers.onBeforeLogout && this.authConfig.eventHandlers.onBeforeLogout(currentUserDetails)) || null,
            onLogout: (this.authConfig && this.authConfig.eventHandlers.onLogout) || null,
        };
    }
    processLogout(currentUserDetails, bypassRoute, onLogout) {
        this.tokenService.clearTokens();
        this._currentUser.next(getDefaultLoggedInUser());
        // after logout was successful, fire onLogout event handler if present
        if (onLogout) {
            onLogout(currentUserDetails);
        }
        // I would rather use the router here, but we run into issues
        // when this gets called from inside an interceptor like it does
        // in the catch of the refresh interceptor on a refresh route.
        // I found this issue so maybe we can revamp this once this is resolved.
        // https://github.com/angular/angular/issues/21149
        if (bypassRoute) {
            this._window.location.reload();
        }
        else {
            this.router.navigate(['/login']);
        }
    }
    /**
     * Gets Observable that determines if there is a current user with a valid token.
     * @returns {Observable<boolean>}
     */
    isAuthenticated() {
        return this.getToken().pipe(catchError(() => of(null)), mergeMap((result) => of(result ? true : false)));
    }
    /**
     * Gets the current users token.  If there is no current user token, this will
     * throw an error.
     * @returns {Observable<ILoginToken>}
     */
    getToken() {
        return this.tokenService.getTokenFromCookie().pipe(switchMap((tokenString) => {
            return this.validateToken(tokenString);
        }));
    }
    /**
     * Gets the current users token.  If there is no current user token, will return
     * null instead.
     * @returns {Observable<ILoginToken>}
     */
    getLoginTokenFromCookie() {
        return this.tokenService.getTokenFromCookie().pipe(map((tokenString) => (tokenString ? JSON.parse(tokenString) : null)));
    }
    /**
     * Validates a tokenString returning the LoginToken from that string.  Throws an error if the tokenString is null.
     * @param {string} tokenString
     * @returns {Observable<ILoginToken>}
     */
    validateToken(tokenString) {
        if (isNull(tokenString)) {
            return throwError(new Error('null token'));
        }
        const token = JSON.parse(tokenString);
        this.appReady.next(true);
        return of(token);
    }
    /**
     * Gets the current xsrf token.  If there is no current xsrf token, this will
     * throw an error.
     * @returns {Observable<string>}
     */
    getXsrfToken() {
        return this.tokenService.getXsrfTokenFromCookie().pipe(switchMap((tokenString) => {
            if (isNullOrWhitespace(tokenString)) {
                return throwError(new Error('null token'));
            }
            else {
                return of(tokenString);
            }
        }));
    }
    /**
     * Safe refresh token, that only tries to refresh once even if called multiple times while refreshing.
     */
    refreshToken() {
        if (this._refreshTokenInProgress) {
            return this._tokenRefreshed$.asObservable().pipe(take(1));
        }
        else {
            this._refreshTokenInProgress = true;
            return this._refreshTokenCall().pipe(tap((loginToken) => {
                this._refreshTokenInProgress = false;
                this._tokenRefreshed$.next(loginToken);
            }));
        }
    }
    /**
     * Call the refresh endpoint to auto refresh the token
     */
    _refreshTokenCall() {
        return this.getLoginTokenFromCookie().pipe(mergeMap((currentToken) => {
            const data = {
                AuthClientID: this.environmentService.config.authClientId,
                AuthClientSecret: this.environmentService.config.authSecretVariable,
                AuthUserId: currentToken.authUserId,
                TokenIdentifier: currentToken.refreshId,
            };
            return this.http
                .post('/authUsers/refresh', data, {
                headers: { BypassAuth: 'true' },
            })
                .pipe(tap((response) => this.saveToken(response, currentToken.remember)), map((response) => mapToken(response, currentToken.remember)));
        }));
    }
    /**
     * Update the current user info and save the token locally
     * @param data
     * @param remember
     */
    saveToken(data, remember) {
        // save current user info
        const token = mapToken(data, remember);
        this._updateCurrentUser(getLoggedInFromToken(token));
        this.tokenService.saveJwtTokenInCookie(token);
        const xsrfToken = data.LoginResult.CsrfToken;
        this.tokenService.saveXsrfTokenInCookie(xsrfToken, remember);
    }
    _updateCurrentUser(updatedUser) {
        const currentUser = this.currentUser.getValue();
        updatedUser.Id = updatedUser.Id || currentUser.Id;
        Object.assign(currentUser, updatedUser);
        this._currentUser.next(currentUser);
    }
    _updateCurrentUserInToken(currentUser) {
        // update login token in cookie
        this.getLoginTokenFromCookie().subscribe((token) => {
            if (!token) {
                return;
            }
            token.customOptions = currentUser.CustomOptions;
            token.name = currentUser.Name;
            token.email = currentUser.Email;
            token.img = currentUser.ProfileImagePath || '';
            this.tokenService.saveJwtTokenInCookie(token);
        });
    }
    /**
     * update the current user value, emitting the new value through the currentUser Observable
     * and update the token in the cookie, so these changes persist.  Pass in only the values
     * that should be changed.
     * @example
     * this.authService.updateCurrentUser({ Name: 'Joe Smith' });
     * @param userValuesToUpdate
     */
    updateCurrentUser(userValuesToUpdate) {
        // ensure the passed in object only has the allowed properties, so that if the param
        // was passed in using any, we are still sure this object doesn't contain other properties
        userValuesToUpdate = this.limitUpdatableUserProps(userValuesToUpdate);
        this._updateCurrentUser(userValuesToUpdate);
        this._updateCurrentUserInToken(this.currentUser.getValue());
    }
    limitUpdatableUserProps(value) {
        const newValue = {};
        if (value.CustomOptions !== undefined) {
            newValue.CustomOptions = value.CustomOptions;
        }
        if (value.Email !== undefined) {
            newValue.Email = value.Email;
        }
        if (value.Name !== undefined) {
            newValue.Name = value.Name;
        }
        if (value.ProfileImagePath !== undefined) {
            newValue.ProfileImagePath = value.ProfileImagePath;
        }
        return newValue;
    }
    /**
     * Generate a forgot password link
     * @param email
     */
    forgot(email) {
        const data = {
            email: email,
        };
        return this.http.post('/users/forgot', data, {
            headers: { BypassAuth: 'true' },
        });
    }
    /**
     * Generate a forgot password link
     * @param resetKey
     */
    adminAccess(resetKey) {
        const data = {
            AuthClientID: this.environmentService.config.authClientId,
            AuthClientSecret: this.environmentService.config.authSecretVariable,
            ResetKey: resetKey,
        };
        return this.http
            .post('/authUsers/adminAccess', data, {
            headers: { BypassAuth: 'true' },
        })
            .pipe(tap((response) => this.saveToken(response, false)));
    }
    resetPassword(userId, password, confirmPassword, resetKey) {
        const data = {
            AuthClientID: this.environmentService.config.authClientId,
            AuthClientSecret: this.environmentService.config.authSecretVariable,
            AuthUserId: userId,
            Confirmation: confirmPassword,
            Password: password,
            ResetKey: resetKey,
        };
        return this.http
            .post('/authUsers/reset', data, {
            headers: { BypassAuth: 'true' },
        })
            .pipe(tap((response) => this.saveToken(response, false)));
    }
    matchPassword(form, formname = 'AuthUser') {
        return matchPassword(form, formname);
    }
}
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(ɵngcc0.ɵɵinject(ɵngcc1.EnvironmentService), ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(TokenService), ɵngcc0.ɵɵinject(ɵngcc4.Router), ɵngcc0.ɵɵinject(WINDOW, 8), ɵngcc0.ɵɵinject(AuthConfig)); };
AuthService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AuthService, factory: AuthService.ɵfac });
AuthService.ctorParameters = () => [
    { type: EnvironmentService },
    { type: HttpClient },
    { type: TokenService },
    { type: Router },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [WINDOW,] }] },
    { type: AuthConfig }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.EnvironmentService }, { type: ɵngcc3.HttpClient }, { type: TokenService }, { type: ɵngcc4.Router }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [WINDOW]
            }] }, { type: AuthConfig }]; }, null); })();

/**
 * Object for defining the role access types. If
 * neither are present then it is assumed that you
 * have no access
 * @property FullAccess
 * @property ReadOnly
 */
var ClaimValues;
(function (ClaimValues) {
    ClaimValues[ClaimValues["FullAccess"] = 1] = "FullAccess";
    ClaimValues[ClaimValues["ReadOnly"] = 2] = "ReadOnly";
})(ClaimValues || (ClaimValues = {}));
class ClaimsService {
    constructor(authService) {
        this.authService = authService;
        this.currentUserClaimValues = {};
        this.setClaims(this.authService.currentUser.getValue());
        this.authService.currentUser.subscribe((currentUser) => this.setClaims(currentUser));
    }
    setClaims(currentUser) {
        this.currentUserClaimValues = currentUser.ClaimValues;
    }
    /**
     * Ichecks the current users claims based on type and looks for match within acceptedValues
     * @param type
     * @param acceptedValues
     */
    hasClaim(type, acceptedValues) {
        const claim = this.currentUserClaimValues[type];
        return claim && acceptedValues.indexOf(claim) >= 0;
    }
}
ClaimsService.ɵfac = function ClaimsService_Factory(t) { return new (t || ClaimsService)(ɵngcc0.ɵɵinject(AuthService)); };
ClaimsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ClaimsService, factory: ClaimsService.ɵfac });
ClaimsService.ctorParameters = () => [
    { type: AuthService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ClaimsService, [{
        type: Injectable
    }], function () { return [{ type: AuthService }]; }, null); })();

class MtAuthGuard {
    constructor(injector) {
        this.window = window;
        this.authService = injector.get(AuthService);
        this.claimsService = injector.get(ClaimsService);
        this.router = injector.get(Router);
        this.notificationsService = injector.get(NotificationsService);
        this.authConfig = injector.get(AuthConfig);
        this.accessRequestsModuleConfigService = injector.get(AccessRequestsModuleConfigService);
    }
    /**
     * Function to determine if the route can be activated.
     * It will set the profile path, check if the user is
     * authenticated and check if their role has access to this route.
     * @param route
     */
    canActivate(route) {
        return forkJoin([
            this.authService.isAuthenticated(),
            this.accessRequestsModuleConfigService.accessRequestsEnabled.pipe(take(1)),
        ])
            .pipe(map(([isAuthenticated, accessRequestsEnabled]) => {
            // user not signed in, send to login page
            if (!isAuthenticated) {
                if (!this.router.url.startsWith(this.authConfig.paths.loginPath)) {
                    this.notificationsService.info(this.authConfig.messages.requiresLoginMessage);
                    const attemptedUrl = this.window.location.href.split('/#')[1];
                    let loginUrl = this.authConfig.paths.loginPath;
                    if (attemptedUrl) {
                        loginUrl += `?${MtAuthGuard.Return_Url_QueryParam}=${attemptedUrl}`;
                    }
                    return this.router.parseUrl(loginUrl);
                }
                return false;
            }
            // now we know the user is signed in
            // do we need to check for user role permission for this route?
            const roleGuard = this.getRoleGuard(route);
            if (roleGuard) {
                let passedRoleGuardCheck = this.claimsService.hasClaim(roleGuard.claimType, roleGuard.claimValues);
                if (!passedRoleGuardCheck) {
                    return this.handleFailedRoleGuardCheck(accessRequestsEnabled, roleGuard);
                }
            }
            // passed all checks
            return true;
        }, this))
            .pipe(catchError((error) => {
            this.notificationsService.info(this.authConfig.messages.requiresLoginMessage);
            return of(this.router.parseUrl(this.authConfig.paths.loginPath));
        }));
    }
    getRoleGuard(route) {
        let isRoleGuarded = route.data && route.data.claimType && route.data.claimValues ? true : false;
        return isRoleGuarded ? route.data : null;
    }
    handleFailedRoleGuardCheck(accessRequestsEnabled, roleGuard) {
        if (accessRequestsEnabled) {
            // If access requests are enabled and the user tried to reach reach a page they do
            // not have access to via RoleGuard, send the user to the no-access-page
            const routeUrl = `${this.accessRequestsModuleConfigService.noAccessPageUrl}/${roleGuard.claimType}`;
            return this.router.parseUrl(routeUrl);
        }
        else if (roleGuard.isHomePage) {
            // if this is the home page, redirect to their profile path
            return this.router.parseUrl(this.authConfig.paths.myProfilePath);
        }
        else {
            // else we need to post a message to notify the user
            this.notificationsService.error(this.authConfig.messages.missingPermissionMessage);
            return this.router.parseUrl(this.authConfig.paths.homePath);
        }
    }
}
MtAuthGuard.Return_Url_QueryParam = 'returnUrl';

class AuthGuard extends MtAuthGuard {
    constructor(injector) {
        super(injector);
    }
}
AuthGuard.ɵfac = function AuthGuard_Factory(t) { return new (t || AuthGuard)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
AuthGuard.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AuthGuard, factory: AuthGuard.ɵfac });
AuthGuard.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthGuard, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class MtCanLoadAuthGuard {
    constructor(injector) {
        this.window = window;
        this.authService = injector.get(AuthService);
        this.claimsService = injector.get(ClaimsService);
        this.router = injector.get(Router);
        this.notificationsService = injector.get(NotificationsService);
        this.authConfig = injector.get(AuthConfig);
    }
    canLoad(route, segments) {
        return this.authService
            .isAuthenticated()
            .pipe(map((isAuthenticated) => {
            // user not signed in, send to login page
            if (!isAuthenticated) {
                if (!this.router.url.startsWith(this.authConfig.paths.loginPath)) {
                    const attemptedUrl = this.window.location.href.split('/#')[1];
                    if (attemptedUrl) {
                        this.router.navigate([this.authConfig.paths.loginPath], {
                            queryParams: { [MtAuthGuard.Return_Url_QueryParam]: attemptedUrl },
                        });
                    }
                    else {
                        this.router.navigate([this.authConfig.paths.loginPath]);
                    }
                    this.notificationsService.info(this.authConfig.messages.requiresLoginMessage);
                }
                return false;
            }
            return true;
        }, this))
            .pipe(catchError((error) => {
            this.router.navigate([this.authConfig.paths.loginPath]);
            this.notificationsService.info(this.authConfig.messages.requiresLoginMessage);
            return of(false);
        }));
    }
}
MtCanLoadAuthGuard.ɵfac = function MtCanLoadAuthGuard_Factory(t) { return new (t || MtCanLoadAuthGuard)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
MtCanLoadAuthGuard.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: MtCanLoadAuthGuard, factory: MtCanLoadAuthGuard.ɵfac });
MtCanLoadAuthGuard.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MtCanLoadAuthGuard, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

/**
 * Pipe to grab an image or other piece of media from the API, with authentication.
 *
 * Usage: <img [src]="urlFromVariable | secureBlob | async" />
 */
class SecureBlobPipe {
    constructor(http, sanitizer) {
        this.http = http;
        this.sanitizer = sanitizer;
    }
    transform(url) {
        return this.http.get(url, { responseType: 'blob' }).pipe(map((res) => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res))));
    }
}
SecureBlobPipe.ɵfac = function SecureBlobPipe_Factory(t) { return new (t || SecureBlobPipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.HttpClient), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer)); };
SecureBlobPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "secureBlob", type: SecureBlobPipe, pure: true });
SecureBlobPipe.ctorParameters = () => [
    { type: HttpClient },
    { type: DomSanitizer }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SecureBlobPipe, [{
        type: Pipe,
        args: [{
                name: 'secureBlob'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: ɵngcc5.DomSanitizer }]; }, null); })();

class BaseApiUrlInterceptor {
    constructor(environmentService) {
        this.environmentService = environmentService;
    }
    /**
     * Intercept all requests and pre-pend the base url from the configuration file
     * @param request
     * @param next
     */
    intercept(request, next) {
        // if the request starts with a slash, then it needs the base api url
        // prepended to the request's url
        if (request.url.startsWith('/')) {
            const dupReq = request.clone({
                url: this.buildUrl(request.url),
            });
            return next.handle(dupReq);
        }
        // else we can just skip this
        return next.handle(request);
    }
    buildUrl(url) {
        if (url.includes('/api/')) {
            return `${this.environmentService.config.baseApiUrl}${url}`;
        }
        else {
            return `${this.environmentService.config.baseApiUrl}/api/v${this.environmentService.config.apiVersion}${url}`;
        }
    }
}
BaseApiUrlInterceptor.ɵfac = function BaseApiUrlInterceptor_Factory(t) { return new (t || BaseApiUrlInterceptor)(ɵngcc0.ɵɵinject(ɵngcc1.EnvironmentService)); };
BaseApiUrlInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BaseApiUrlInterceptor, factory: BaseApiUrlInterceptor.ɵfac });
BaseApiUrlInterceptor.ctorParameters = () => [
    { type: EnvironmentService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BaseApiUrlInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.EnvironmentService }]; }, null); })();

class RefreshInterceptor {
    constructor(injector) {
        this.injector = injector;
    }
    /**
     * looks for requests to refresh endpoint and logs out the user if a refresh fails.
     * also looks for token-expired or x-update-roles headers on non-refresh end points
     * that fail, and if found runs the tokenRefresh and retries these requests.
     * @param request
     * @param next
     */
    intercept(request, next) {
        if (!this.authService) {
            this.authService = this.injector.get(AuthService);
        }
        if (!this.tokenService) {
            this.tokenService = this.injector.get(TokenService);
        }
        // if this is a refresh request, then hook into it and logout if error
        if (request.url.endsWith('authUsers/refresh')) {
            return next.handle(request).pipe(catchError((error) => {
                this.authService.logout(true);
                return throwError(error);
            }));
        }
        // otherwise we catch errors with the header X-Update-Roles OR Expired-Token
        // and attempt to refresh and push response again
        return next.handle(request).pipe(catchError((error) => {
            const tokenRefreshNeeded = error instanceof HttpErrorResponse &&
                (error.headers.has('X-Update-Roles') || error.headers.has('token-expired'));
            if (tokenRefreshNeeded) {
                return this.handleTokenRefresh(next, request);
            }
            return throwError(error);
        }), finalize(() => {
            this.authService.appReady.next(true);
        }));
    }
    /**
     * reissue the next.handle for a request after a successful refreshToken call has been completed
     * @param next
     * @param request
     */
    handleTokenRefresh(next, request) {
        return forkJoin([this.authService.refreshToken(), this.tokenService.getXsrfTokenFromCookie()]).pipe(switchMap(([loginToken, xsrfToken]) => {
            request = this.addAuthHeader(request, loginToken.token, xsrfToken);
            return next.handle(request);
        }), catchError((innerError) => {
            // refresh request error hook above will logout the user
            return throwError(innerError);
        }));
    }
    /**
     * add the authentication headers from the new token returned from refreshToken
     * @param request
     * @param token
     * @param xsrfToken
     */
    addAuthHeader(request, token, xsrfToken) {
        if (token) {
            return request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                    'X-XSRF-TOKEN': xsrfToken,
                },
            });
        }
        return request;
    }
}
RefreshInterceptor.ɵfac = function RefreshInterceptor_Factory(t) { return new (t || RefreshInterceptor)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
RefreshInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: RefreshInterceptor, factory: RefreshInterceptor.ɵfac });
RefreshInterceptor.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RefreshInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class TokenInterceptor {
    constructor(injector) {
        this.injector = injector;
    }
    /**
     * Interceptor that will check if you are making an authorized request.
     * If you are it will attach the token information, if not it will only
     * attach the xsrf token.
     * @param request
     * @param next
     */
    intercept(request, next) {
        if (!this.authService) {
            this.authService = this.injector.get(AuthService);
        }
        if (!this.tokenService) {
            this.tokenService = this.injector.get(TokenService);
        }
        return forkJoin(this.authService.getLoginTokenFromCookie(), this.tokenService.getXsrfTokenFromCookie()).pipe(mergeMap((tokenValues) => {
            const [tokenObj, xsrfToken] = tokenValues;
            if (isNull(tokenObj) ||
                !tokenObj.token ||
                isNullOrWhitespace(xsrfToken)) {
                return next.handle(request);
            }
            const unauthorizedRequest = request.headers.get('BypassAuth');
            let headers = {};
            if (unauthorizedRequest) {
                headers = {
                    'X-XSRF-TOKEN': xsrfToken,
                };
            }
            else {
                headers = {
                    Authorization: `Bearer ${tokenObj.token}`,
                    'X-XSRF-TOKEN': xsrfToken,
                };
            }
            const dupReq = request.clone({
                setHeaders: headers,
            });
            return next.handle(dupReq);
        }));
    }
}
TokenInterceptor.ɵfac = function TokenInterceptor_Factory(t) { return new (t || TokenInterceptor)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
TokenInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: TokenInterceptor, factory: TokenInterceptor.ɵfac });
TokenInterceptor.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TokenInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class CacheBusterInterceptor {
    constructor(authConfig) {
        this.authConfig = authConfig;
    }
    /**
     * Interceptor adds headers to keep IE 11 from cacheing get requests.
     * @param request
     * @param next
     */
    intercept(request, next) {
        const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
        if (!isIEOrEdge) {
            return next.handle(request);
        }
        const cacheBusterIgnoreHandler = this.authConfig.eventHandlers.cacheBusterIgnoreHandler;
        if (cacheBusterIgnoreHandler) {
            const ignoreCacheBuster = cacheBusterIgnoreHandler(request);
            if (ignoreCacheBuster) {
                return next.handle(request);
            }
        }
        const httpRequest = request.clone({
            setHeaders: {
                'Cache-Control': 'no-cache',
                Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
                Pragma: 'no-cache',
            },
        });
        return next.handle(httpRequest);
    }
}
CacheBusterInterceptor.ɵfac = function CacheBusterInterceptor_Factory(t) { return new (t || CacheBusterInterceptor)(ɵngcc0.ɵɵinject(AuthConfig)); };
CacheBusterInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CacheBusterInterceptor, factory: CacheBusterInterceptor.ɵfac });
CacheBusterInterceptor.ctorParameters = () => [
    { type: AuthConfig }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CacheBusterInterceptor, [{
        type: Injectable
    }], function () { return [{ type: AuthConfig }]; }, null); })();

class AuthModule {
    static forRoot(authConfig) {
        return {
            ngModule: AuthModule,
            providers: [
                AuthGuard,
                MtCanLoadAuthGuard,
                ClaimsService,
                AuthService,
                SecureBlobPipe,
                { provide: HTTP_INTERCEPTORS, useClass: BaseApiUrlInterceptor, multi: true },
                { provide: HTTP_INTERCEPTORS, useClass: RefreshInterceptor, multi: true },
                { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
                { provide: HTTP_INTERCEPTORS, useClass: CacheBusterInterceptor, multi: true },
                { provide: AuthModuleConfigToken, useValue: authConfig },
                { provide: WINDOW, useFactory: _window },
            ],
        };
    }
}
AuthModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AuthModule });
AuthModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AuthModule_Factory(t) { return new (t || AuthModule)(); }, imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AuthModule, { declarations: [SecureBlobPipe], exports: [SecureBlobPipe] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthModule, [{
        type: NgModule,
        args: [{
                declarations: [SecureBlobPipe],
                exports: [SecureBlobPipe],
                imports: []
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AuthConfig, AuthGuard, AuthModule, AuthModuleConfigToken, AuthService, BaseApiUrlInterceptor, BehaviorSubjectWithoutNext, CacheBusterInterceptor, ClaimValues, ClaimsService, MtAuthGuard, MtCanLoadAuthGuard, RefreshInterceptor, SecureBlobPipe, TokenInterceptor, WINDOW, _window, getDefaultLoggedInUser, getLoggedInFromToken, handlerExecuteSafe, mapToken, matchPassword, stitchCustomOptions, TokenService as ɵa };

//# sourceMappingURL=mt-ng2-auth-module.js.map